import moment from 'moment'
import validator from 'validator'
import { verifyLength } from 'variables/functions'

export function bookingInfoFormValidation(values, errors) {
  if (values.meeting) {
    if (verifyLength(values.meeting, 250)) {
      Object.assign(errors, { meetingPlace: 'Meeting cannot be longer than 250 characters' })
    }
  }
  if (values.customer) {
    if (values.customer.name) {
      if (verifyLength(values.customer.name, 52)) {
        Object.assign(errors, { memo: 'Customer Name cannot be longer than 52 characters' })
      }
    }
  }
  if (values.memo) {
    if (verifyLength(values.memo, 2000)) {
      Object.assign(errors, { memo: 'Message to Photographer cannot be longer than 2000 characters' })
    }
  }
  if (values.privateNotes) {
    if (verifyLength(values.privateNotes, 2000)) {
      Object.assign(errors, { privateNotes: 'Private Notes cannot be longer than 2000 characters' })
    }
  }
  if (values.date) {
    if (!moment(values.uDate, 'MM/DD/YYYY h:mm A', true).isValid()) {
      Object.assign(errors, { memo: 'Incorrect datetime format' })
    }
  }
  if (values.taxRate) {
    if (values.taxRate > 1) {
      Object.assign(errors, { taxRate: 'Tax rate cannot be more than 100%' })
    }
    if (values.taxRate < 0) {
      Object.assign(errors, { taxRate: 'Tax rate cannot be negative' })
    }
  }
  return errors
}

export const bookingSubmitValidation = (values, errors, photographerName) => {
  Object.assign(errors, { label: 'The following must be completed to submit form ' })
  if (values.customer.name) {
    if (verifyLength(values.customer.name, 52)) {
      Object.assign(errors, { memo: 'Customer Name cannot be longer than 52 characters' })
    }
  }

  if (values.customer) {
    if (!values.customer.email || !values.customer.name) {
      if (!values.customer.email) {
        Object.assign(errors, { email: '- Valid Customer Email' })
      }
      if (!values.customer.name) {
        Object.assign(errors, { name: '- Valid Customer Name' })
      }
    } else {
      // CHECKING TO SEE IF VALID EMAIL WITH REGEX
      if (
        // !/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
        //   values.customer.email,
        // )
        !validator.isEmail(values.customer.email)
      ) {
        Object.assign(errors, { email: '- Valid Customer Email' })
      }
    }
  }
  if (!values.meetingPlace) {
    Object.assign(errors, { meetingPlace: '- Meeting Spot' })
  }
  if (!values.memo) {
    if (!!photographerName) {
      Object.assign(errors, { memo: `- Message to ${photographerName}` })
    } else {
      Object.assign(errors, { memo: `- Message to Client` })
    }
  }
  if (values.taxRate) {
    if (values.taxRate > 1) {
      Object.assign(errors, { taxRate: '- Tax rate cannot be more than 100%' })
    }
    if (values.taxRate < 0) {
      Object.assign(errors, { taxRate: '- Tax rate cannot be negative' })
    }
  }

  if (values.meetingPlace) {
    if (verifyLength(values.meetingPlace, 250)) {
      Object.assign(errors, { meetingPlace: '- Meeting cannot be longer than 250 characters' })
    }
  }
  if (values.customer) {
    if (values.customer.name) {
      if (verifyLength(values.customer.name, 52)) {
        Object.assign(errors, { memo: '- Customer Name cannot be longer than 52 characters' })
      }
    }
  }
  if (values.memo) {
    if (verifyLength(values.memo, 2000)) {
      if (!!photographerName) {
        Object.assign(errors, {
          memo: `- Message to ${photographerName} cannot be longer than 2000 characters`,
        })
      } else {
        Object.assign(errors, { memo: '- Message to Client cannot be longer than 2000 characters' })
      }
    }
  }
  if (values.date) {
    if (!moment(values.uDate, 'MM/DD/YYYY h:mm A', true).isValid()) {
      Object.assign(errors, { memo: '- Incorrect datetime format' })
    }
  }

  if (values.paymentDue) {
    if (values.paymentDue < 0) {
      Object.assign(errors, { paymentDue: '- Amount due cannot be negative' })
    }
  }
  if (values.privateNotes) {
    if (verifyLength(values.privateNotes, 2000)) {
      Object.assign(errors, { privateNotes: '- Private Notes cannot be longer than 2000 characters' })
    }
  }
  if (values.phone) {
    if (verifyLength(values.phone, 45)) {
      Object.assign(errors, { phone: '- Private Notes cannot be longer than 45 characters' })
    }
  }
  return errors
}

export const publicBookingSubmitValidation = (errors, packageForm) => {
  Object.assign(errors, { label: 'The following must be completed to submit form' })

  packageForm.slice(1).forEach((el) => {
    if (el.fieldType === 1) {
      if (!el.fieldValue && el.required) {
        Object.assign(errors, { [el.fieldLabel]: 'Name cannot be empty' })
      } else if (!!el.fieldValue && verifyLength(el.fieldValue, 52)) {
        Object.assign(errors, { [el.fieldLabel]: 'Customer Name cannot be longer than 52 characters' })
      }
    } else if (el.fieldType === 5) {
      if (!el.fieldValue && el.required) {
        Object.assign(errors, { [el.fieldLabel]: 'Email cannot be empty' })
      } else if (!!el.fieldValue && !validator.isEmail(el.fieldValue)) {
        // !/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
        //  el.fieldValue,
        Object.assign(errors, { [el.fieldLabel]: 'Invalid Email' })
      }
    } else if (el.fieldType === 4) {
      if (!el.fieldValue && el.required) {
        Object.assign(errors, { [el.fieldLabel]: 'Phone number cannot be empty' })
      } else if (!!el.fieldValue && el.fieldValue.length > 50) {
        Object.assign(errors, { [el.fieldLabel]: 'Phone number cannot exceed 50 digits' })
      } else if (!!el.fieldValue && !validator.isMobilePhone(el.fieldValue)) {
        Object.assign(errors, { [el.fieldLabel]: 'Invalid Mobile Phone Number' })
      }
    } else if (el.fieldType === 2) {
      if (!el.fieldValue && el.required) {
        Object.assign(errors, { [el.fieldLabel]: 'Message cannot be empty' })
      } else if (!!el.fieldValue && el.fieldValue.length > 1000) {
        Object.assign(errors, { [el.fieldLabel]: 'Message cannot exceed 1000 characters' })
      }
    }
  })
  return errors
}
